import React from "react";
import SiteLayout from "../components/SiteLayout";
import HowItWorks from "../components/sections/HowItWorks";
import StatsBar from "../components/sections/StatsBar";
import CTASection from "../components/sections/CTASection";

export default function HowItWorksPage() {
  return (
    <SiteLayout>
      <section className="pt-20 pb-12">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 max-w-3xl">
          <div className="eyebrow mb-4">How it works</div>
          <h1 className="font-display text-5xl sm:text-6xl font-bold tracking-tight">From order to placement in 4 quiet steps.</h1>
          <p className="mt-6 text-inkSoft text-lg">No threads to chase. No spreadsheets to maintain. Whether it's link building or a technical audit — order, brief, ship.</p>
        </div>
      </section>
      <HowItWorks />
      <StatsBar />
      <CTASection />
    </SiteLayout>
  );
}
